export default class TipoAvaliacao {
  constructor({ sigla, descricao, anoLetivoId, limiteAvaliacao }) {
    this.sigla = sigla;
    this.descricao = descricao;
    this.anoLetivoId = anoLetivoId;
    this.limiteAvaliacao = limiteAvaliacao;
  }
}
